import React, { useEffect } from "react";
export default function UpdateEventsImageModal({ open, form, setForm, errors, onClose, onSubmit }) {
    useEffect(() => {
        if (!open) return;
        const onKeyDown = (e) => e.key === "Escape" && onClose();
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [open, onClose]);
    if (!open) return null;

    function handleChange(e) {
        const file= e.target.files[0];

        setForm((p) => ({ ...p, image: file }));
    }
    return (
        <div
            role="dialog"
            aria-modal="true"
            onMouseDown={ (e) => e.target === e.currentTarget && onClose() }
            style={ {
                position: "fixed",
                inset: 0,
                background: "rgba(5, 5, 5, 0.47)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 16,
                zIndex: 2000,
            } }
        >
            <div
                className="card admin-card"
                style={ {
                    width: "min(980px, 100%)",
                    maxHeight: "90vh",
                    overflow: "auto",
                } }
            >
                <div className="card-body p-4">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                        <h5 className="mb-0 text-light">
                            Upload New Image for {form.title}
                        </h5>
                        <button className="btn btn-sm btn-outline-light" onClick={ onClose }>
                            ✕
                        </button>
                    </div>

                    <form
                        onSubmit={ (e) => {
                            e.preventDefault();
                            onSubmit();
                        } }
                    >
                        <div className="row g-3">
                            <div className="col-12 col-md-6">
                                <label className="form-label text-white-50">Select Image*</label>
                                <input
                                    className={ `form-control bg-dark text-light border-secondary ${errors.title ? "is-invalid" : ""
                                        }` }
                                    type="file"
                                    accept="image/*"
                                    name="image"
                                    onChange={ handleChange }
                                />
                                { errors.title && (
                                    <div className="invalid-feedback">{ errors.title }</div>
                                ) }
                            </div>
                        </div>

                        <div className="d-flex justify-content-end gap-2 mt-4">
                            <button
                                type="button"
                                className="btn btn-outline-light"
                                onClick={ onClose }
                            >
                                Cancel
                            </button>
                            <button type="submit" className="btn btn-primary">
                                Update Event
                            </button>
                            
                        </div>
                    </form>
                </div>
            </div>
            
        </div>
    );
}